import "core-js/modules/es.object.assign";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};
/**
 * 灵犀统计
 */


import { env } from './env';
import { getQueryObject, SOURCE_STORAGE_KEYS } from './util';
var LX_CATEGORY = 'order_c';
/**
 * 获取上报埋点时用于区分业务方(businessSource)、业务场景(businessSourceFrom)的参数
 * @param sourceParamName 需要获取的业务参数名称
 * @returns sourceParam 业务参数的值
 */

function getSourceParam(sourceParamName) {
  var sourceParam = '';

  try {
    var query = getQueryObject(location.href);
    var querySourceParam = query[sourceParamName] || '';
    var STORAGE_KEY = SOURCE_STORAGE_KEYS[sourceParamName];
    var storageSourceParam = localStorage.getItem(STORAGE_KEY) || '';
    sourceParam = querySourceParam || storageSourceParam; // query 中有业务参数时，重置缓存

    if (querySourceParam) {
      localStorage.setItem(STORAGE_KEY, querySourceParam);
    }
  } catch (error) {
    console.warn("getSourceParam: " + sourceParamName + " fail", error);
  }

  return sourceParam;
}

function getDefaultCustom() {
  var query = getQueryObject(location.href);
  var defaultCustom = {
    businessSource: getSourceParam('businessSource') || '',
    businessSourceFrom: getSourceParam('businessSourceFrom') || '',
    source: query.source || '',
    token: query.token || '',
    userid: query.userid || '',
    uuid: query.uuid || '',
    appChannel: query.appChannel || '',
    appName: env.appChannel || '',
    browse_type: query.appChannel || '',
    invMakeType: query.invMakeType || '',
    businessType: query.bizType || '',
    subBizType: query.subBizType || '',
    bizScene: query.bizScene || '',
    business: query.business || '',
    specialInvoice: env.specialInvoice || '',
    lxs: env.lxs || ''
  };
  return defaultCustom;
}

var Analytics =
/** @class */
function () {
  function Analytics() {}

  Analytics.prototype.reportPV = function (cid, lab, val_lab) {
    if (lab === void 0) {
      lab = {};
    }

    if (val_lab === void 0) {
      val_lab = {};
    }

    if (!('LXAnalytics' in window && cid)) {
      return;
    }

    window['LXAnalytics']('getTracker', LX_CATEGORY)('pageView', __assign({
      custom: __assign({}, getDefaultCustom(), lab, Analytics.commonParams)
    }, val_lab), Analytics.environment, cid);
  };

  Analytics.prototype.reportModule = function (reportModuleType, bid, lab, options) {
    if (lab === void 0) {
      lab = {};
    }

    if (options === void 0) {
      options = {};
    }

    if (!('LXAnalytics' in window && bid)) {
      return;
    }

    window['LXAnalytics'](reportModuleType, bid, {
      custom: __assign({}, getDefaultCustom(), lab)
    }, options);
  }; // https://docs.sankuai.com/lx/web/#31  options 中可以指定cid，因为存在1个bid对应多个cid的情况


  Analytics.prototype.reportMC = function (bid, lab, options) {
    if (lab === void 0) {
      lab = {};
    }

    if (options === void 0) {
      options = {};
    }

    this.reportModule('moduleClick', bid, lab, options);
  };

  Analytics.prototype.reportMV = function (bid, lab, options) {
    if (lab === void 0) {
      lab = {};
    }

    if (options === void 0) {
      options = {};
    }

    this.reportModule('moduleView', bid, lab, options);
  };

  Analytics.prototype.reportME = function (bid, lab, options) {
    if (lab === void 0) {
      lab = {};
    }

    if (options === void 0) {
      options = {};
    }

    this.reportModule('moduleEdit', bid, lab, options);
  };

  Analytics.environment = {
    msid: env.queryStrings.msid || env.cookies.IJSESSIONID || env.cookies.JSESSIONID || '',
    // 灵犀自动获取uuid，业务方不用上报
    // uuid: env.uuid,
    uid: env.uid,
    logintype: env.cookies.logintype || '',
    appnm: env.app,
    app: env.version,
    cityid: env.cityId || '',
    ua: navigator.userAgent
  };
  Analytics.commonParams = {
    from: env.appChannel
  };
  return Analytics;
}();

export var analytics = new Analytics();